import {IDeserializable} from '@app/core/models/deserializable.model';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';

export class Pagination implements IDeserializable {
	public current_page: number;
	public from: number;
	public last_page: number;
	public per_page: number;
	public to: number;
	public total: number;

	public getQOPagination(): IQOPagination {
		return {
			currentPage: this.current_page,
			nextPage: this.current_page === this.last_page ? null : this.current_page + 1,
			pageSize: this.per_page,
			totalItems: this.total,
			totalPages: this.last_page,
		};
	}

	public pageToGet(itemsLeftInThisPage: number): number | null {
		const onLastPage = this.last_page === this.current_page;
		const onFirstPage = this.current_page === 1;
		const shouldGetPreviousPage = !onFirstPage && onLastPage && itemsLeftInThisPage === 0;
		if (shouldGetPreviousPage || !onLastPage) {
			return shouldGetPreviousPage ? this.current_page - 1 : this.current_page;
		}

		return null;
	}

	public deserialize(input: any): this {
		Object.assign(this, input);

		return this;
	}
}

export class PaginationHolder<T> {

	public data: T[];

	public pagination: Pagination;
}
